import { createContext, useContext } from 'react'

/**
 * Where components that portal out of their parent (the language panel) should
 * mount. `null` (the default) means document.body, which is what the website
 * uses. The embeddable header (src/embed) provides a node inside its shadow
 * root, so the portalled panel keeps the header's scoped styles.
 */
export const PortalContainerContext = createContext<Element | DocumentFragment | null>(null)

export function usePortalContainer(): Element | DocumentFragment | null {
  return useContext(PortalContainerContext)
}
